import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export const oAuthConfig: AuthConfig = {
  issuer: environment.issuer,
  clientId: environment.cgb,
  redirectUri: window.location.origin + '/loginsuccess',
  responseType: 'code',
  scope: environment.scpgb,
  strictDiscoveryDocumentValidation: true,
  requireHttps: environment.production,
  showDebugInformation: false,
  disablePKCE: false,
  skipIssuerCheck: false,
  sessionChecksEnabled: true,
  timeoutFactor: 0.75,
  waitForTokenInMsec: 1000,
  clearHashAfterLogin: true,
  disableAtHashCheck: false,
  nonceStateSeparator: 'semicolon',
  customQueryParams: {
    prompt: 'login',
    'X-Content-Type-Options': 'nosniff',
    'X-Frame-Options': 'DENY',
  },
};
